import { Outlet } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { PageSkeleton } from 'modules/meetings/components/Skeletons/PageSkeleton'
import { MeetingTranscriptProvider } from 'modules/meetings/lib/context/MeetingTranscriptContext/MeetingTranscriptProvider'
import { MeetingsContextProvider } from 'modules/meetings/lib/context/MeetingsContext/MeetingsProvider'
import { MeetingsMeetingProvider } from 'modules/meetings/lib/context/MeetingsMeetingContext/MeetingsMeetingProvider'
import { useMeetingsContext } from 'modules/meetings/lib/hooks/useMeetingsContext'

const MeetingPageWrapper = () => {
  const { canSeeMeetings, loading } = useMeetingsContext()

  if (loading) {
    return <PageSkeleton />
  }

  const authorizeFn = () => {
    return canSeeMeetings
  }

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <Outlet />
    </AuthorizeUser>
  )
}

function MeetingRootPage() {
  return (
    <MeetingsContextProvider>
      <MeetingsMeetingProvider>
        <MeetingTranscriptProvider>
          <MeetingPageWrapper />
        </MeetingTranscriptProvider>
      </MeetingsMeetingProvider>
    </MeetingsContextProvider>
  )
}
export default MeetingRootPage
